/**
 * Format centimes as EUR string (e.g. 1 234,50 €).
 *
 * @param centimes - amount in centimes
 * @param decimals - fraction digits (default 2)
 */
export function formatEur(centimes: number, decimals = 2): string {
  return (
    (centimes / 100).toLocaleString("fr-FR", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }) + " €"
  );
}
